import { useRef, useCallback } from "react";

export function useDisableScrollOnFocus() {
  const wheelHandlerRef = useRef((e) => {
    e.preventDefault(); // block mouse wheel increment/decrement
  });

  const onFocus = useCallback((e) => {
    e.currentTarget.addEventListener("wheel", wheelHandlerRef.current, { passive: false });
  }, []);

  const onBlur = useCallback((e) => {
    e.currentTarget.removeEventListener("wheel", wheelHandlerRef.current);
  }, []);

  const onKeyDown = useCallback((e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault(); // optional: block arrow keys too
    }
  }, []);

  // return props to spread into <input>
  return { onFocus, onBlur, onKeyDown };
}
